/**
 * Exposes some public readonlyants that can be used by the scripts.
 *
 * @since 5.0.4.230626
 */
export class Definitions {
	public static readonly ERR_REST_HTTP_ERROR = 3001;
	public static readonly ERR_REST_INVALID_API_RESPONSE = 3002;
}